export default {
  TableHeadMarketingReport: [
    [
      {
        displayName: 'marketingReport.table_head.no',
      },
      {
        displayName: 'marketingReport.table_head.name',
      },
      {
        displayName: 'marketingReport.table_head.winlose',
      },
      {
        displayName: 'marketingReport.table_head.pendingWinlose',
      },
    ],
  ],
};
